var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcRejectCross(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4098_4613",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.640625,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4098_4613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0725 12L16.8441 9.22831C17.2395 8.83293 17.2395 8.19191 16.8441 7.79653C16.4487 7.40116 15.8078 7.40116 15.4124 7.79653L12.6407 10.5682L9.86904 7.79653C9.47367 7.40116 8.83265 7.40116 8.43728 7.79653C8.0419 8.19191 8.0419 8.83293 8.43728 9.22831L11.2089 12L8.43728 14.7717C8.0419 15.1671 8.0419 15.8081 8.43728 16.2035C8.63496 16.4011 8.89406 16.5 9.15315 16.5C9.41224 16.5 9.67135 16.4012 9.86902 16.2035L12.6407 13.4318L15.4124 16.2035C15.6101 16.4011 15.8691 16.5 16.1282 16.5C16.3873 16.5 16.6464 16.4012 16.8441 16.2035C17.2395 15.8081 17.2395 15.1671 16.8441 14.7717L14.0725 12Z",
    fill: "#9C4900"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.05729,
    y: 2.41667,
    width: 19.1667,
    height: 19.1667,
    rx: 3.75,
    stroke: "#9C4900",
    strokeWidth: 0.833333
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRejectCross);
export default __webpack_public_path__ + "static/media/ic_reject_cross.acde8cf7134a859f473953b143af0ec0.svg";
export { ForwardRef as ReactComponent };